export const apiBaseUrl = process.env.REACT_APP_API_ENDPOINT || "/api/"
export const authBaseUrl = process.env.REACT_APP_AUTH_ENDPOINT || "/"